import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgPauseIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27.04h1.25v16H5.27v-16Zm4.25 0h1.25v16H9.52v-16Z",
    fill: "currentColor"
  }));
}

export { SvgPauseIcon as default };
